import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { BuildVersionComponent } from '../navigation/build-version/build-version.component';



@NgModule({
  declarations: [
    BuildVersionComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule
  ],
  exports: [
    TranslateModule,
    BuildVersionComponent
  ]
})
export class HomeModule { }
